import React, { useState, useEffect } from 'react';
import { FiMessageCircle } from 'react-icons/fi';
import ChatWindow from './ChatWindow';
import chatService from '../../services/chatService';
import socketService from '../../services/socketService';
import './ChatButton.css';

const ChatButton = ({ vendor, currentUser, token, onClose }) => {
  const [isOpen, setIsOpen] = useState(true); // Auto-open when component mounts
  const [conversation, setConversation] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token && !socketService.isConnected()) {
      socketService.connect(token);
    }

    return () => {
      // Don't disconnect on unmount as other components might be using it
    };
  }, [token]);

  useEffect(() => {
    if (isOpen && !conversation) {
      loadOrCreateConversation();
    }
  }, [isOpen, conversation]);

  const loadOrCreateConversation = async () => {
    try {
      setLoading(true);
      
      // Try to find existing conversation with this vendor
      const conversationsData = await chatService.getConversations({ 
        type: 'vendor_team' 
      });
      
      const existingConversation = conversationsData.conversations?.find(
        conv => conv.vendor_id === vendor.id
      );

      if (existingConversation) {
        setConversation(existingConversation);
      } else {
        // Create new conversation
        const newConversation = await chatService.createConversation({
          title: `Chat with ${vendor.company_name}`,
          type: 'vendor_team',
          vendorId: vendor.id,
          participantUserIds: []
        });
        setConversation(newConversation);
      }
    } catch (error) {
      console.error('Error loading/creating conversation:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="chat-modal-overlay" onClick={handleClose}>
      <div className="chat-modal-content" onClick={(e) => e.stopPropagation()}>
        {loading ? (
          <div className="chat-loading-container">
            <div className="spinner"></div>
            <p>Loading chat...</p>
          </div>
        ) : conversation ? (
          <ChatWindow
            conversation={conversation}
            onClose={handleClose}
            currentUser={currentUser}
          />
        ) : (
          <div className="chat-error-container">
            <p>Unable to load chat. Please try again.</p>
            <button onClick={handleClose}>Close</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatButton;


